<template>
	<div class="owl-carousel">
		<template v-for="(item, i) in items">
			<a v-if="item.banner"
				:href="item.href"
				class="item banner"
				:style="`background-image: url(${item.img})`"
				>
				<p class="infoSlider">{{i+1}} из {{items.length}}</p>
			</a>
			<div class="item" v-else :style="`background-image: url(${item.img})`">
				<div class="flexContainer">
					<div class="row">
						<div class="cols s_24 m_16 l_13">
							<div class="topBlock">
								<p v-if="item.title" class="title">{{item.title}}</p>
								<p v-if="item.text" class="text">{{item.text}}</p>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="cols s_24">
							<div class="flexBlock">
								<template v-if="item.popup">
									<a v-if="item.button" :data-key="item.button_key" :href="item.popup" data-fancybox class="yam-button  waves-effect waves-light">{{item.button}}</a>
								</template>
								<template v-else>
									<a v-if="item.button" :href="item.href" class="yam-button  waves-effect waves-light">{{item.button}}</a>
								</template>
								<p class="infoSlider">{{i+1}} из {{items.length}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>

	</div>
</template>

<script>
module.exports = {

	props: ['items'],

	data () {
		return {}
	},

	updated() {
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: this.items.length > 1 ? true : false,
				nav: true,
				dots: true
			},
			onInitialized: function() {
				$('.owl-next, .owl-prev').addClass('waves-effect waves-light');
			}
		});
	}
}
</script>

<style lang="scss">
@import "scss/wanted";
.global-slider-container {
	position: relative;
	.slider-mainSlider {
		box-shadow: 0px 1px 4px rgba(242, 242, 242, 4);
		border-radius: 2px;
		background-color: white;
		margin-bottom: 30px;
		@include m___up{
			margin-bottom: 0;
		}
		height: 380px;
		overflow: hidden;
		.owl-carousel {
			.item {
				height: 380px;
				background-repeat: no-repeat;
				padding: rem(30) rem(30) rem(50);
				display: block;
				text-align: center;
				background-size: contain;
				background-position: center;
				@include m_up{
					text-align: left;
					padding: rem(60);
				}
				.flexContainer{
					height: 100%;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
				}
				.title{
					font-size: rem(24);
					line-height: rem(36);
					color: #393d4c;
					font-weight: bold;
					margin-bottom: 18px;
					max-height: rem(108);
					overflow: hidden;
				}
				.text{
					font-size: rem(15);
					line-height: rem(26);
					color: #393d4c;
					font-weight: 500;
					max-height: rem(78);
					overflow: hidden;
				}
				.yam-button{
					max-width: 200px;
					width: 200px;
					margin: auto;
					@include m_up{
						margin: 0;
					}
				}

				.flexBlock{
					align-items: center;
					display: flex;
				}
				.infoSlider{
					position: absolute;
					top: 30px;
					right: 60px;
					margin: 3px 0 0 156px;
					font-size: rem(14);
					font-weight: 600;
					line-height: rem(26);
					color: #a1a1ac;
					display: none;
					@include m_up{
						display: flex;
					}
				}
			}
			.banner{
				background-size: contain;
				background-position: center;
				@include l_up{
					background-size: cover;
				}
			}
		}
		.owl-nav{
			position: absolute;
			bottom: 62px;
			right: 60px;
			display: none;
			@include m_up{
				display: flex;
			}
			.owl-next, .owl-prev{
				width: 45px;
				height: 45px;
				font-size: 0;
				background-color: #fff;
				border: 1px solid #dbdbdf;
				background-image: url('../img/slArr.png');
				background-position: center;
				background-repeat: no-repeat;
				border-radius: 100%;
				margin-left: 15px;
				@include single-transition();
				&.owl-prev{
					transform: rotate(180deg);
				}
				&:hover{
					background-color: #006eb6;
					border-color: #006eb6;
					filter: brightness(100%);
					background-image: url('../img/slArr2.png');
				}
			}
		}
		.owl-dots{
			justify-content: center;
			padding-bottom: 3px;
			position: absolute;
			display: flex;
			align-items: center;
			height: 30px;
			width: 100%;
			bottom: 9px;
			@include m_up{
				display: none;
			}
			.owl-dot{
				display: flex;
				width: 10px;
				height: 10px;
				margin: 0 7px;
				justify-content: center;
				align-items: center;
				border: 2px solid rgba(black, .5);
				border-radius: 50%;
				transition: 0.4s ease-in-out;
				position: relative;
				span{
					transition: 0.4s ease-in-out;
					width: 4px;
					border-radius: 50%;
					height: 4px;
					background-color: transparent;
					display: inline-block;
					position: absolute;
					margin: 0 auto;
					top: calc(50% - 2px);
					left: calc(50% - 2px);
				}
				&.active{
					border-color: #005e9c;
					span{
						// background-color: #005e9c;
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// mainSlider.vue?5c1b3ec3